<template>
  <div class="">
    <div class="c-p-20 c-bg-white">
      <div class="c-flex c-m-b-15">
        <div class="store_image_con">
          <img class="full_img" :src="vpnInfo.imgUrl" />
        </div>

        <div class="c-p-5">
          <div class="c-m-b-10 c-ft-26 c-m-b-20 c-black">
            {{ vpnInfo.Name }}
          </div>
          <div class="c-lightgrey c-m-b-5 c-ft-22">
            营业时间： {{ vpnInfo.BusinessStartTime }}-{{
              vpnInfo.BusinessEndTime
            }}
          </div>
        </div>
      </div>
      <div class="f-bt phone_con bottom_line_con c-ft-22" @click="phone">
        <div class="">
          {{ vpnInfo.Phone }}
        </div>
        <div class="">
          <img src="@/assets/svg/phone.svg" style="width: 16px" />
        </div>
      </div>
      <div class="f-bt address_con c-ft-22" @click="toAddress">
        <div class="">
          {{ vpnInfo.Address }}
        </div>
        <div class="">
          <img src="@/assets/svg/address.svg" style="width: 16px" />
        </div>
      </div>
    </div>

    <div class="c-p-20 c-bg-white c-m-t-18 c-p-b-80">
      <div class="f-bt c-p-tb-12 bottom_line_con">
        <div class="c-flex c-ft-26">
          <div class="c-m-r-6">
            <img src="@/assets/images/queue.png" style="width: 16px" />
          </div>
          <div class="">排队取号</div>
        </div>
        <div class="c-lightgrey c-ft-22" v-if="isEnabledQueue">
          等待时间仅供参考
        </div>
      </div>
      <!-- 餐饮排队 -->
      <template v-if="isFromType == 1">
        <template v-if="isEnabledQueue">
          <div class="taked_number_list">
            <div
              v-for="(item, index) in takeNumberList"
              :key="index"
              class="c-flex taked_number_item"
            >
              <div class="c-f-1 c-t-l" v-if="item.ClassName">
                <div class="c-black c-m-b-8">
                  {{ item.ClassName }}
                </div>
                <div class="">{{ item.PeopleNumTxt }}</div>
              </div>
              <div class="c-f-1 c-t-c">
                排队
                <span class="wait_number_con">{{ item.AheadCount }}</span> 桌
              </div>
              <div class="c-f-1 c-t-r">
                约 {{ item.BurningTime ? item.BurningTime : "--" }} 分钟
              </div>
            </div>
          </div>
          <div class="c-lightgrey c-ft-22">
            听到叫号请到迎宾台，过号作废实际规则以线下门店说明为准。
          </div>
          <div class="taked_number_con f-bt c-ft-26" v-if="queueInfo.Id">
            <div class="c-flex c-f-1">
              <div class="c-f-1 c-flex-column">
                <div class="c-ft-38 bold c-black c-m-b-12">
                  {{ queueInfo.QueueNumber }}
                </div>
                <div>
                  {{ queueInfo.ClassName ? queueInfo.ClassName : "单号" }}
                  <!-- ({{ queueInfo.QueueTablePerson }}人) -->
                </div>
              </div>
              <div class="c-f-1 c-flex-column">
                <div class="c-m-b-12">
                  <span class="wait_number_con">{{ queueInfo.WaitCount }}</span>
                  桌
                </div>

                <div class="">还需等待</div>
              </div>
              <div class="c-f-1 c-flex-column">
                <div class="c-m-b-12">
                  <span class="wait_number_con">{{
                    queueInfo.PredictTime || "--"
                  }}</span>
                  分钟
                </div>

                <div class="">预计等待时长</div>
              </div>
            </div>
            <div class="">
              <van-button
                color="#FF6C62"
                plain
                size="small"
                @click="handleViewTakedNumber"
                >查看</van-button
              >
              <!-- <my-button btnTitle="查看" widthData="150px" paddingData="8px 12px" bgColor="#fff"
							borderData="1px solid #FF6C62" color="#FF6C62" @handleClickBtnFunc="handleViewTakedNumber">

						</my-button> -->
            </div>
          </div>
        </template>
        <div class="no_queue_text" v-else>当前暂停取号</div>
      </template>
      <!-- 入场排队 -->
      <template v-if="isFromType == 3">
        <template v-if="isEnabledQueue">
          <div class="taked_number_list">
            <div class="c-flex taked_number_item">
              <div class="c-f-1 c-t-l">
                排队
                <span class="wait_number_con">{{ waitInfo.AheadCount }}</span>
                组
              </div>
              <div class="c-f-1 c-t-r">
                约
                {{ waitInfo.BurningTime ? waitInfo.BurningTime : "--" }} 分钟
              </div>
            </div>
          </div>

          <div class="taked_number_con f-bt c-ft-26" v-if="queueInfo.Id">
            <div class="c-flex c-f-1">
              <div class="c-f-1 c-flex-column">
                <div class="c-ft-38 bold c-black c-m-b-12">
                  {{ queueInfo.QueueNumber }}
                </div>
                <div>
                  单号
                  <!-- ({{ queueInfo.QueueTablePerson }}人) -->
                </div>
              </div>
              <div class="c-f-1 c-flex-column">
                <div class="c-m-b-12">
                  <span class="wait_number_con">{{ queueInfo.WaitCount }}</span>
                  组
                </div>

                <div class="">还需等待</div>
              </div>
              <div class="c-f-1 c-flex-column">
                <div class="c-m-b-12">
                  <span class="wait_number_con">{{
                    queueInfo.PredictTime || "--"
                  }}</span>
                  分钟
                </div>

                <div class="">预计等待时长</div>
              </div>
            </div>
            <div class="">
              <van-button
                color="#FF6C62"
                plain
                size="small"
                @click="handleViewTakedNumber"
                >查看</van-button
              >
              <!-- <my-button btnTitle="查看" widthData="150px" paddingData="8px 12px" bgColor="#fff"
							borderData="1px solid #FF6C62" color="#FF6C62" @handleClickBtnFunc="handleViewTakedNumber">

						</my-button> -->
            </div>
          </div>
          <div class="c-m-t-90" v-if="!queueInfo.Id">
            <div class="guest_number_con fc-center">
              <div class="f-bt guest_number_item w-100% c-m-b-35">
                <div class="guest_title">男宾</div>
                <div class="guest_stepper_con">
                  <van-stepper
                    :value="guestInfo.Man"
                    theme="round"
                    button-size="22"
                    min="0"
                    disable-input
                    :show-minus="guestInfo.Man > 0"
                    :show-input="guestInfo.Man > 0"
                    @change="(e) => onGoodsNumChange(e, 'Man')"
                  />
                </div>
              </div>
              <div class="f-bt guest_number_item w-100% c-m-b-35">
                <div class="guest_title">女宾</div>
                <div class="guest_stepper_con">
                  <van-stepper
                    :value="guestInfo.Woman"
                    theme="round"
                    button-size="22"
                    min="0"
                    disable-input
                    :show-minus="guestInfo.Woman > 0"
                    :show-input="guestInfo.Woman > 0"
                    @change="(e) => onGoodsNumChange(e, 'Woman')"
                  />
                </div>
              </div>
              <div class="f-bt guest_number_item w-100%">
                <div class="guest_title">儿童</div>
                <div class="guest_stepper_con">
                  <van-stepper
                    :value="guestInfo.Child"
                    theme="round"
                    button-size="22"
                    min="0"
                    disable-input
                    :show-minus="guestInfo.Child > 0"
                    :show-input="guestInfo.Child > 0"
                    @change="(e) => onGoodsNumChange(e, 'Child')"
                  />
                </div>
              </div>
            </div>
            <div class="c-t-c c-m-t-140 c-grey-6 c-ft-24">
              合计 <i class="wait_number_con">{{ totalNum }}</i> 人
            </div>
          </div>
        </template>
        <div class="no_queue_text" v-else>当前暂停取号</div>
      </template>
    </div>
    <div class="bottom_submit_con" v-if="isEnabledQueue && !queueInfo.Id">
      <div class="block_btn_con">
        <van-button
          color="linear-gradient(90deg, #FF9F55 0%, #FF6B62 100%)"
          @click="handleGetNumber"
          :loading="isSubmiting"
          block
          >立即取号</van-button
        >
      </div>

      <!-- <my-button btnTitle="立即取号" widthData="280px" paddingData="20px 32px" borderRadius="8px"
				bgColor="linear-gradient(90deg, #FF9F55 0%, #FF6B62 100%);" @handleClickBtnFunc="handleGetNumber">

			</my-button> -->
    </div>

    <van-popup
      class="people_number_con"
      v-model="isTableNumberShow"
      mode="center"
      round
      :closeable="false"
      @close="isTableNumberShow = false"
    >
      <div class="card_info_con c-p-24 c-p-b-25">
        <div class="c-m-b-24">
          <span class="c-p-tb-7 c-ft-30">请选择就餐人数</span>
        </div>
        <ul class="table_number_con">
          <li
            v-for="(item, index) in 15"
            :class="[{ active_item: tableNumber == item }, 'table_number_item']"
            :key="index"
            @click="onClickTableNumber(item)"
          >
            {{ item }}
          </li>
          <li
            :class="[
              { active_item: tableNumber == 'more' },
              'table_number_item',
            ]"
            @click="onClickTableNumber('more')"
          >
            更多
          </li>
        </ul>
        <van-field
          v-if="tableNumber == 'more'"
          v-model="inputTableNumber"
          type="digit"
          label="人数"
          placeholder="请输入人数"
        />
        <!-- <uni-easyinput v-if="tableNumber=='more'" v-model="inputTableNumber" type="number" placeholder="请输入人数"
					></uni-easyinput> -->
        <div class="c-f-center c-m-t-30 c-m-b-20">
          <div class="c-m-r-15 w-140">
            <van-button
              color="#DEDEDE"
              plain
              round
              size="small"
              block
              @click="isTableNumberShow = false"
              >取消</van-button
            >
            <!-- <my-button btnTitle="取消" widthData="120px" paddingData="8px 12px" bgColor="#fff"
							borderData="1px solid #DEDEDE" color="#DEDEDE"
							@handleClickBtnFunc="isTableNumberShow=false">

						</my-button> -->
          </div>
          <div class="w-140">
            <van-button
              color="#FF6C62"
              plain
              round
              block
              size="small"
              @click="handleSubmitNumber"
              >确定</van-button
            >
          </div>
          <!-- <my-button btnTitle="确定" widthData="120px" paddingData="8px 12px" bgColor="#fff"
						borderData="1px solid #FF6C62" color="#FF6C62" @handleClickBtnFunc="handleSubmitNumber">

					</my-button> -->
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { handleLocalStorage } from "@/utils/index";
import { handleSessionStorage } from "@/utils";

import wxConfig from "@/utils/wxConfig.js";
import { verifyNeedWechatMember } from "@/utils/gFunc";
import { getQueueHistory, takeQueueNumber } from "@/api/quenu.js";
export default {
  data() {
    return {
      isFromType: 1,
      vpnInfo: {},
      isEnabledQueue: false,
      allVpnList: [],
      takeNumberList: [
        // {
        //   ClassName: "小桌",
        //   PeopleNumTxt: "1-2",
        //   AheadCount: 12,
        //   BurningTime: 15,
        // },
        // {
        //   ClassName: "中桌",
        //   PeopleNumTxt: "3-4",
        //   AheadCount: 20,
        //   BurningTime: 35,
        // },
        // {
        //   ClassName: "大桌",
        //   PeopleNumTxt: "5-10",
        //   AheadCount: 3,
        //   BurningTime: 40,
        // },
      ],
      isTableNumberShow: false,
      tableNumber: 1,
      inputTableNumber: "",
      queueInfo: {},
      waitInfo: { AheadCount: "--" },
      // {
      //   Status: 1,
      //   VpnName: "水裹",
      //   QueueNumber: "A02",
      //   ClassName: "小桌",
      //   QueueTablePerson: "1-3",
      //   QueueTime: "2023-05-22 12:23:45",
      //   WaitCount: 15,
      //   PredictTime: 26,
      // },
      guestInfo: {
        Woman: 0,
        Man: 0,
        Child: 0,
      },
      isSubmiting: false,
    };
  },
  watch: {
    "$store.state.vpnId"(val) {
      const vpnItem = this.allVpnList.find((v) => {
        return v.Id === val;
      });
      this.vpnInfo = vpnItem;
      console.log("watch===========");
      console.log(this.vpnInfo);
      this.handleGetAllQueueList();
    },
  },
  computed: {
    totalNum() {
      return this.guestInfo.Woman + this.guestInfo.Man + this.guestInfo.Child;
    },
  },
  mounted() {
    this.isFromType = this.$route.query.type || 1;
    this.init();
  },
  methods: {
    init() {
      const _this = this;
      if (localStorage.getItem("allStoreList")) {
        handleSetVpn();
      } else {
        window.addEventListener("setItem", () => {
          console.log("setItem触发=====================");
          handleSetVpn();
        });
      }
      function handleSetVpn() {
        _this.allVpnList = JSON.parse(localStorage.getItem("allStoreList"));
        let getVpnId = _this.$store.state.vpnId;
        const vpnItem = _this.allVpnList.find((v) => {
          return v.Id === getVpnId;
        });
        if (getVpnId && vpnItem) {
          _this.handleSetStoreImg(vpnItem);
          _this.vpnInfo = vpnItem;
        } else {
          _this.handleSetStoreImg(_this.allVpnList[0]);
          _this.vpnInfo = _this.allVpnList[0];
        }
        console.log("门店信息如下");
        console.log(_this.vpnInfo);
        _this.handleGetAllQueueList();
      }
    },
    handleSetStoreImg(vpnItem) {
      const imgArr = vpnItem.Claims;
      if (imgArr instanceof Array && imgArr.length > 0) {
        const imgItem = imgArr.find((subItem) => subItem.TypeId === 0);
        if (imgItem) {
          vpnItem.imgUrl = `${imgItem.CdnUrl}/${imgItem.Value}`;
        }
      }
    },
    phone() {
      $pub.toTel(this.vpnInfo.Phone);
    },
    toAddress() {
      if (
        this.vpnInfo.Latitude &&
        this.vpnInfo.Longitude &&
        this.vpnInfo.Name &&
        this.vpnInfo.Address
      ) {
        wxConfig.consultMap(
          this,
          this.vpnInfo.Latitude,
          this.vpnInfo.Longitude,
          this.vpnInfo.Name,
          this.vpnInfo.Address
        );
      } else {
        this.$toast("请在后台完善经纬度等信息");
      }
    },
    // handleInitVpnInfo() {
    // 	const vpnInfo = handleLocalStorage.get('vpnInfo')
    // 	const imgArr = vpnInfo.Claims;
    // 	if (imgArr instanceof Array && imgArr.length > 0) {
    // 		const imgItem = imgArr.find((subItem) => subItem.TypeId === 0);
    // 		if (imgItem) {
    // 			vpnInfo.imgUrl = `${imgItem.CdnUrl}/${imgItem.Value}`;
    // 		}
    // 	}
    // 	this.vpnInfo = vpnInfo
    // },
    handleGetAllQueueList() {
      // handleSessionStorage.set("vpnInfo", this.vpnInfo);
      this.isEnabledQueue =
        this.isFromType == 1
          ? this.vpnInfo.SaasVpnSetting.EnableCateringQueuingUp
          : this.vpnInfo.SaasVpnSetting.EnableEntranceQueuingUp;
      getQueueHistory({
        type: this.isFromType,
        vpnId: this.vpnInfo.Id,
      }).then((res) => {
        this.queueInfo = res.CurrentQueuingUpModel;
        this.takeNumberList = res.WxQueuingUpData || [];
        if (this.isFromType == 3 && res.WxQueuingUpData[0]) {
          this.waitInfo = res.WxQueuingUpData[0];
        }
      });
    },
    handleGetNumber() {
      // 验证该场景是否需要强制注册微会员
      verifyNeedWechatMember(this.isFromType == 3 ? 4 : 3, () => {
        if (this.isFromType == 3) {
          this.handleSubmitNumber();
        } else {
          this.isTableNumberShow = true;
        }
      });
    },
    onClickTableNumber(num) {
      this.tableNumber = num;
    },
    handleSubmitNumber() {
      if (this.isFromType == 3) {
        if (!this.totalNum) {
          this.$toast("请添加宾客");
          return;
        }
        let consumerUrl = "";
        if (this.guestInfo.Man > 0) {
          consumerUrl += this.guestInfo.Man + "男";
        }
        if (this.guestInfo.Woman > 0) {
          consumerUrl += this.guestInfo.Woman + "女";
        }
        if (this.guestInfo.Child > 0) {
          consumerUrl += this.guestInfo.Child + "儿童";
        }
        this.isSubmiting = true;
        takeQueueNumber({
          type: this.isFromType,
          vpnId: this.$store.state.vpnId,
          personnelType: consumerUrl,
        })
          .then((res) => {
            this.isSubmiting = false;
            this.$router.push({
              name: "TakeNumberSuccess",
              query: { takeNumberId: res, type: this.isFromType },
              // 1567474267586561
            });
          })
          .catch(() => {
            this.isSubmiting = false;
          });
      } else {
        if (!this.tableNumber) {
          this.$toast("请选择就餐人数");
          return;
        }
        if (this.tableNumber == "more" && !this.inputTableNumber) {
          this.$toast("请输入就餐人数");
          return;
        }
        this.isTableNumberShow = false;
        takeQueueNumber({
          type: this.isFromType,
          vpnId: this.$store.state.vpnId,
          peopleCount:
            this.tableNumber == "more"
              ? this.inputTableNumber
              : this.tableNumber,
        }).then((res) => {
          this.$router.push({
            name: "TakeNumberSuccess",
            query: { takeNumberId: res, type: this.isFromType },
            // 1567474267586561
          });
        });
      }
    },
    handleViewTakedNumber() {
      this.$router.push({
        name: "TakeNumberSuccess",
        query: { takeNumberId: this.queueInfo.Id, type: this.isFromType },
      });
    },
    onGoodsNumChange(val, type) {
      this.guestInfo[type] = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.store_image_con {
  width: 160px;
  height: 160px;
  border-radius: 20px;
  overflow: hidden;
  margin-right: 10px;
}

.phone_con {
  padding: 12px 0;
  color: #666;
}

.address_con {
  padding: 15px 0;
  color: #666;
}

.bottom_line_con {
  border-bottom: 1px solid #dedede;
}

.taked_number_list {
  color: #666;
  margin-top: 20px;
  font-size: 22px;

  .taked_number_item {
    align-items: center;
    background: #fef5f6;
    border-radius: 8px;
    border: 1px solid rgba(255, 108, 98, 0.5);
    padding: 23px 23px;
    margin-bottom: 20px;

    .wait_number_con {
      color: #ff6c62;
      font-size: 34px;
      font-weight: bold;
      margin: 0 8px;
    }
  }
}

.no_queue_text {
  padding: 100px 0;
  text-align: center;
}

.bottom_submit_con {
  @include fixed-bottom-box-con;
  padding: 0 0 64px;
  display: flex;
  justify-content: center;
  border-top: none;
  background: unset;
  .block_btn_con {
    width: 320px;
  }
}

.table_number_con {
  display: flex;
  flex-wrap: wrap;

  .table_number_item {
    padding: 15px;
    box-sizing: border-box;
    width: 23.5%;
    text-align: center;
    border: 1px solid #dcdde0;
    border-radius: 5px;
    color: #323233;
    margin-right: 10px;
    margin-bottom: 10px;
    font-size: 26px;

    &.active_item {
      background: #ffece3;
      border: 1px solid #ff6923;
      color: #ff6923;
    }

    &:nth-child(4n) {
      margin-right: 0;
    }
  }
}

.taked_number_con {
  margin-top: 30px;
}
.wait_number_con {
  color: #ff6c62;
  font-size: 34px;
  font-weight: bold;
  margin: 0 10px;
}
.people_number_con {
  width: 90%;
}
.guest_number_item {
  padding: 0 23%;
  box-sizing: border-box;
  .guest_title {
    font-size: 30px;
  }
}
.guest_stepper_con {
  ::v-deep {
    .van-stepper--round .van-stepper__plus {
      background: #ff9e55;
    }
    .van-stepper--round .van-stepper__minus {
      background: #ff9e55;
      color: #fff;
      border: none;
    }
  }
}
</style>
